import { Action } from 'redux';
import { put } from 'redux-saga/effects';

import { BasketActions } from '../basket.types';
import { api } from 'repositories/api';
import { DonationModel } from 'models/Basket';
import { ACTION_CREATOR_NAME, errorToBasketErrorModel } from 'helpers';
import { BasketActionTypes } from '../';
import { ErrorAction } from 'store';
import { BasketSagaReturnType } from 'store/sagaHelpers';

export interface LoadDonationAction extends Action<BasketActionTypes.LOAD_DONATION> {
}

export interface LoadDonationActionStart extends Action<BasketActionTypes.LOAD_DONATION_START> {
}

export interface LoadDonationActionSuccess extends Action<BasketActionTypes.LOAD_DONATION_SUCCESS> {
    donation: DonationModel;
}

export interface LoadDonationActionError extends ErrorAction<BasketActionTypes.LOAD_DONATION_ERROR> {
}

export const loadDonation: () => LoadDonationAction = () => ({
    type: BasketActionTypes.LOAD_DONATION
});
loadDonation[ACTION_CREATOR_NAME] = 'loadDonation';

export type LoadDonationFunc = (...args: Parameters<typeof loadDonation>) => void;

export function* loadDonationSaga(): BasketSagaReturnType {
    yield put<BasketActions>({
        type: BasketActionTypes.LOAD_DONATION_START
    });

    try {
        const charities = yield api.donation.getDonations();

        yield put<BasketActions>({
            type: BasketActionTypes.LOAD_DONATION_SUCCESS,
            donation: charities
        });

        return true;
    } catch (error) {
        yield put<BasketActions>({
            type: BasketActionTypes.LOAD_DONATION_ERROR,
            error: errorToBasketErrorModel(error, 'loadDonationSaga')
        });

        return false;
    }
}